import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_RISORSA_LORA } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIdRisorsaLORAState extends EntityState<IID_RISORSA_LORA, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_RISORSA_LORA , realtimeEntity: 'IID_RisorsaLora'})
@InterfaceDataStore(InterfaceName.RISORSA_LORA)
export class IIDRisorsaLORAStore extends EntityStore<IIdRisorsaLORAState> {
  constructor() {
    super([]);
  }
}
